import { debounce } from '../../utils/debounce'
import { BaseComponent } from '../../components/base-component'
import { $el, $list } from 'src/scripts/utils/utils'

const CONTAINER_SELECTOR = '[data-scrolling-text-container]'
const LINE_SELECTOR = 'scrolling-text-line'

export class ScrollingText extends BaseComponent {
  resizeObserver: ResizeObserver
  paddings: number

  mountComponent(): void {
    const container = $el(CONTAINER_SELECTOR, this)

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(container)
  }

  unmountComponent(): void {
    this.resizeObserver.disconnect()
  }

  calcHeight = (): number => {
    const container = $el(CONTAINER_SELECTOR, this)
    const styles = getComputedStyle(container)

    this.paddings = parseInt(styles.paddingTop) + parseInt(styles.paddingBottom)

    const lines = $list(LINE_SELECTOR, this)
    let heightToSet: number

    const firstLineRect = lines[0].getBoundingClientRect()

    if (lines.length > 1) {
      const coordsTop: number[] = []
      const coordsBottom: number[] = []

      const lastLineRect = lines[lines.length - 1].getBoundingClientRect()

      coordsTop.push(firstLineRect.top)
      coordsTop.push(lastLineRect.top)
      coordsBottom.push(firstLineRect.bottom)
      coordsBottom.push(lastLineRect.bottom)

      heightToSet =
        coordsBottom.sort((a, b) => b - a)[0] -
        coordsTop.sort((a, b) => a - b)[0]
    } else {
      heightToSet = firstLineRect.height
    }

    return heightToSet
  }

  setHeight = (): void => {
    this.style.setProperty('--gsc-section-height', `${this.calcHeight()}px`)
  }

  handleResize = debounce((): void => {
    this.setHeight()
  }, 100)
}
